import { ProctoringEvent } from "./store/slices/proctoringSession";
import { VideoEvent } from "../../utilities/useTimestamps";

export default function convertEventFormat(event: ProctoringEvent): VideoEvent {
	return {
		...event,
		key: `event-${event.id}`,
		time: event.time / 1000,
		details: event.details as Record<string, any>,
		flag_level: event.anomaly?.flagLevel ?? 0,
		comment: event.anomaly?.comment,
		resolved: event.anomaly?.resolved ?? false,
		logged_time: event.createdAt,
	};
}
